module.exports = __webpack_public_path__ + "static/media/MCCD.b90cff68.png";